(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.bsBound) return;
      const track = root.querySelector('[data-bslider-track]');
      if (!track) return;
      root.dataset.bsBound = 'true';
      const n = track.children.length;
      const update = () => {
        const w = track.clientWidth || 1;
        const p = Math.max(0, Math.min(n - 1, track.scrollLeft / w));
        root.style.setProperty('--bs-p', p);
      };
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { update(); ticking = false; });
      }, { passive: true });
      root.querySelectorAll('[data-bslider-bar]').forEach((bar) => {
        bar.addEventListener('click', (e) => {
          const r = bar.getBoundingClientRect();
          const i = Math.min(n - 1, Math.max(0, Math.floor(((e.clientX - r.left) / r.width) * n)));
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
      window.addEventListener('resize', update);
      update();
    };
    const init = (scope = document) => scope.querySelectorAll('[data-bslider]').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-page"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creation-moments"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.momentsBound) return;
      const track = root.querySelector('[data-moments-track]');
      if (!track) return;
      const originals = Array.from(track.querySelectorAll('[data-moments-card]'));
      const n = originals.length;
      if (!n) return;
      root.dataset.momentsBound = 'true';

      // Endless loop: put a full copy of the cards before and after the originals
      if (n > 1) {
        const copy = (c) => {
          const k = c.cloneNode(true);
          k.removeAttribute('data-shopify-editor-block');
          k.setAttribute('aria-hidden', 'true');
          k.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          k.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          return k;
        };
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        originals.forEach((c) => { before.appendChild(copy(c)); after.appendChild(copy(c)); });
        track.insertBefore(before, track.firstChild);
        track.appendChild(after);
      }

      const cards = Array.from(track.querySelectorAll('[data-moments-card]'));
      const center = (card) => card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2;
      const activeIndex = () => {
        const i = cards.findIndex((c) => c.classList.contains('is-active'));
        return i < 0 ? (n > 1 ? n : 0) : i;
      };
      const goTo = (i, smooth = true) => {
        const idx = Math.min(cards.length - 1, Math.max(0, i));
        track.scrollTo({ left: center(cards[idx]), behavior: smooth ? 'smooth' : 'auto' });
      };

      const update = () => {
        const mid = track.scrollLeft + track.clientWidth / 2;
        let best = cards[0];
        let bestDist = Infinity;
        cards.forEach((card) => {
          const d = Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid);
          if (d < bestDist) { bestDist = d; best = card; }
        });
        cards.forEach((card) => {
          const active = card === best;
          card.classList.toggle('is-active', active);
          const video = card.querySelector('video');
          if (video) {
            if (active) { video.play().catch(() => {}); } else { video.pause(); }
          }
        });
      };

      // After scrolling settles inside a copy, silently swap to the identical card in the middle set
      let settleTimer;
      const settle = () => {
        if (n < 2) return;
        const i = activeIndex();
        if (i >= n && i < 2 * n) return;
        const target = n + (i % n);
        root.classList.add('is-jumping');
        track.style.scrollSnapType = 'none';
        track.scrollLeft = center(cards[target]);
        update();
        void track.offsetWidth;
        requestAnimationFrame(() => {
          track.style.scrollSnapType = '';
          requestAnimationFrame(() => root.classList.remove('is-jumping'));
        });
      };

      let ticking = false;
      track.addEventListener('scroll', () => {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 140);
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { update(); ticking = false; });
      }, { passive: true });

      root.classList.add('is-jumping');
      goTo(n > 1 ? n : 0, false);
      update();
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('is-jumping')));
      window.addEventListener('resize', () => { goTo(activeIndex(), false); update(); });

      // Arrow buttons
      const prevBtn = root.querySelector('[data-m-prev]');
      const nextBtn = root.querySelector('[data-m-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => goTo(activeIndex() - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(activeIndex() + 1));

      // Auto-advance (endless)
      if (root.dataset.autoplay === 'true' && n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const delay = Math.max(2, parseInt(root.dataset.interval, 10) || 5) * 1000;
        let paused = false;
        let inView = true;
        ['mouseenter', 'touchstart', 'focusin'].forEach((ev) => root.addEventListener(ev, () => { paused = true; }, { passive: true }));
        ['mouseleave', 'touchend', 'focusout'].forEach((ev) => root.addEventListener(ev, () => { paused = false; }, { passive: true }));
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => { inView = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(root);
        }
        setInterval(() => {
          if (paused || !inView || document.hidden) return;
          goTo(activeIndex() + 1);
        }, delay);
      }
    };

    const init = (scope = document) => scope.querySelectorAll('[data-moments]').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  if (!window.customHeaderStickyStateInitialized) {
    window.customHeaderStickyStateInitialized = true;

    let stickyStateFrameId = null;

    const updateCustomHeaderStickyState = () => {
      stickyStateFrameId = null;

      const header = document.querySelector('.section-custom-header > header');
      if (!(header instanceof HTMLElement)) return;

      const hasOverlayHero = Boolean(
        document.querySelector('#MainContent > .shopify-section:first-child .simply-hero-section')
      );
      const stickyContainer = header.closest('#header-group') || header;
      const isSticky = !hasOverlayHero || (window.scrollY > 0 && stickyContainer.getBoundingClientRect().top <= 0);
      header.classList.toggle('custom-header--sticky', isSticky);
    };

    const scheduleCustomHeaderStickyState = () => {
      if (stickyStateFrameId !== null) return;

      stickyStateFrameId = window.requestAnimationFrame(updateCustomHeaderStickyState);
    };

    window.addEventListener('scroll', scheduleCustomHeaderStickyState, { passive: true });
    window.addEventListener('resize', scheduleCustomHeaderStickyState);
    document.addEventListener('DOMContentLoaded', scheduleCustomHeaderStickyState, { once: true });
    document.addEventListener('shopify:section:load', scheduleCustomHeaderStickyState);
    document.addEventListener('shopify:section:unload', scheduleCustomHeaderStickyState);
    document.addEventListener('shopify:section:reorder', scheduleCustomHeaderStickyState);
    scheduleCustomHeaderStickyState();
  }

  if (!window.customHeaderMobilePullInitialized) {
    window.customHeaderMobilePullInitialized = true;

    const mobileMediaQuery = window.matchMedia('(max-width: 989px)');
    const maxPullOffset = 56;
    const pullResistance = 96;
    const gestureIntentThreshold = 8;
    let activeHeader = null;
    let startX = 0;
    let startY = 0;
    let gestureAxis = null;
    let topReachedY = null;
    let currentPullOffset = 0;
    let isTouchTracking = false;
    let frameId = null;
    let pendingOffset = 0;
    let pendingPulling = false;

    const getMobileHeader = () => {
      if (!mobileMediaQuery.matches) return null;

      return document.querySelector('.section-custom-header > header');
    };

    const applyPullOffset = (header, offset, isPulling) => {
      header.style.setProperty('--custom-header-pull-offset', `${offset}px`);
      header.dataset.pulling = isPulling && offset > 0 ? 'true' : 'false';
    };

    const flushPullOffset = () => {
      frameId = null;

      if (!activeHeader) return;

      applyPullOffset(activeHeader, pendingOffset, pendingPulling);
    };

    const schedulePullOffset = (header, offset, isPulling) => {
      const nextPulling = isPulling && offset > 0;
      const nextOffset = Number(offset.toFixed(2));

      pendingOffset = nextOffset;
      pendingPulling = nextPulling;

      if (frameId !== null) return;

      frameId = window.requestAnimationFrame(flushPullOffset);
    };

    const resetPullState = () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
        frameId = null;
      }

      if (!activeHeader) return;

      applyPullOffset(activeHeader, 0, false);
      activeHeader = null;
      currentPullOffset = 0;
      startX = 0;
      startY = 0;
      gestureAxis = null;
      topReachedY = null;
      isTouchTracking = false;
      pendingOffset = 0;
      pendingPulling = false;
    };

    document.addEventListener(
      'touchstart',
      (event) => {
        activeHeader = getMobileHeader();

        if (!activeHeader || event.touches.length === 0) return;

        const touch = event.touches[0];

        startX = touch.clientX;
        startY = touch.clientY;
        gestureAxis = null;
        topReachedY = window.scrollY <= 0 ? startY : null;
        currentPullOffset = 0;
        isTouchTracking = true;
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      (event) => {
        if (!activeHeader || !isTouchTracking || event.touches.length === 0) return;

        const touch = event.touches[0];
        const currentX = touch.clientX;
        const currentY = touch.clientY;
        const horizontalDistance = Math.abs(currentX - startX);
        const verticalDistance = Math.abs(currentY - startY);

        if (gestureAxis === null) {
          if (Math.max(horizontalDistance, verticalDistance) < gestureIntentThreshold) return;

          gestureAxis = horizontalDistance > verticalDistance ? 'horizontal' : 'vertical';
        }

        if (gestureAxis === 'horizontal') return;

        const touchDelta = currentY - startY;

        if (touchDelta <= 0) {
          topReachedY = window.scrollY <= 0 ? currentY : null;

          if (currentPullOffset > 0) {
            currentPullOffset = 0;
            schedulePullOffset(activeHeader, 0, false);
          }

          return;
        }

        if (window.scrollY > 0) {
          topReachedY = null;

          if (currentPullOffset > 0) {
            currentPullOffset = 0;
            schedulePullOffset(activeHeader, 0, false);
          }

          return;
        }

        if (topReachedY === null) {
          topReachedY = currentY;
        }

        const pullDistance = currentY - topReachedY;

        if (pullDistance <= 0) return;

        currentPullOffset = maxPullOffset * (1 - Math.exp(-pullDistance / pullResistance));
        schedulePullOffset(activeHeader, currentPullOffset, true);
      },
      { passive: true }
    );

    document.addEventListener('touchend', resetPullState, { passive: true });
    document.addEventListener('touchcancel', resetPullState, { passive: true });
    window.addEventListener(
      'scroll',
      () => {
        if (!isTouchTracking) {
          resetPullState();
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', resetPullState);
    document.addEventListener('shopify:section:unload', resetPullState);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simply-product-information"] && !Shopify.designMode) return;
  try {
    
  class FullScreenSlideshow extends HTMLElement {
    connectedCallback() {
      this.previousDocumentOverflow = '';
      this.sourceSlideshow = document.getElementById(this.dataset.sourceSlideshowId || '');
      this.slideshow = this.querySelector('[data-product-media-slideshow]');
      this.prevButton = this.querySelector('.full-screen-prev-btn');
      this.nextButton = this.querySelector('.full-screen-next-btn');
      this.currentSlide = this.querySelector('[data-current-slide]');
      this.totalSlides = this.querySelector('[data-total-slides]');
      this.closeButton = this.querySelector('.full-screen-close-btn');
      this.controls = this.querySelector('full-screen-slideshow-controls');
      this.onClick = this.onClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onSourceChange = this.onSourceChange.bind(this);
      this.onSlideshowChange = this.onSlideshowChange.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);

      if (!(this.slideshow instanceof HTMLElement)) {
        return;
      }

      this.addEventListener('click', this.onClick);
      this.addEventListener('transitionend', this.onTransitionEnd);
      document.addEventListener('keydown', this.onKeyDown);
      this.slideshow.addEventListener('product-media-slideshow:change', this.onSlideshowChange);
      this.sourceSlideshow?.addEventListener('product-media-slideshow:change', this.onSourceChange);
      this.updateControls(this.slideshow.currentIndex || 0, this.slideshow.slides?.length || 0);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('transitionend', this.onTransitionEnd);
      document.removeEventListener('keydown', this.onKeyDown);
      this.slideshow?.removeEventListener('product-media-slideshow:change', this.onSlideshowChange);
      this.sourceSlideshow?.removeEventListener('product-media-slideshow:change', this.onSourceChange);
      this.unlockScroll();
    }

    open(index = 0) {
      if (!(this.slideshow instanceof HTMLElement)) {
        return;
      }

      this.hidden = false;
      this.setAttribute('aria-hidden', 'false');
      this.dataset.state = 'closed';
      this.lockScroll();
      this.slideshow.select(index);
      this.updateControls(this.slideshow.currentIndex || 0, this.slideshow.slides?.length || 0);

      requestAnimationFrame(() => {
        this.slideshow.refreshLayout();
        this.dataset.state = 'open';
      });
    }

    close() {
      if (this.hidden) {
        return;
      }

      this.setAttribute('aria-hidden', 'true');
      this.dataset.state = 'closed';
      this.unlockScroll();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.hidden = true;
      }
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;

      if (!target) {
        return;
      }

      const previousButton = target.closest('.full-screen-prev-btn');
      if (previousButton instanceof HTMLElement) {
        this.slideshow?.previous();
        return;
      }

      const nextButton = target.closest('.full-screen-next-btn');
      if (nextButton instanceof HTMLElement) {
        this.slideshow?.next();
        return;
      }

      const closeButton = target.closest('.full-screen-close-btn');
      if (closeButton instanceof HTMLElement) {
        this.close();
        return;
      }

      if (target === this) {
        this.close();
      }
    }

    onKeyDown(event) {
      if (this.hidden) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.slideshow?.previous();
        return;
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.slideshow?.next();
      }
    }

    onSourceChange(event) {
      if (this.hidden) {
        return;
      }

      if (this.slideshow?.currentIndex === event.detail.currentIndex) {
        return;
      }

      this.slideshow?.select(event.detail.currentIndex);
    }

    onSlideshowChange(event) {
      const { currentIndex, slideCount } = event.detail;

      this.updateControls(currentIndex, slideCount);

      if (this.sourceSlideshow?.currentIndex === currentIndex) {
        return;
      }

      this.sourceSlideshow?.select(currentIndex);
    }

    onTransitionEnd(event) {
      if (event.target !== this || event.propertyName !== 'transform') {
        return;
      }

      if (this.dataset.state === 'closed' && this.getAttribute('aria-hidden') === 'true') {
        this.hidden = true;
      }
    }

    updateControls(currentIndex, slideCount) {
      const hasMultipleSlides = slideCount > 1;

      if (this.currentSlide instanceof HTMLElement) {
        this.currentSlide.textContent = String(currentIndex + 1);
      }

      if (this.totalSlides instanceof HTMLElement) {
        this.totalSlides.textContent = String(slideCount);
      }

      if (this.prevButton instanceof HTMLButtonElement) {
        this.prevButton.hidden = !hasMultipleSlides;
        this.prevButton.disabled = currentIndex === 0;
      }

      if (this.nextButton instanceof HTMLButtonElement) {
        this.nextButton.hidden = !hasMultipleSlides;
        this.nextButton.disabled = !hasMultipleSlides || currentIndex === slideCount - 1;
      }
    }

    lockScroll() {
      if (this.previousDocumentOverflow === '') {
        this.previousDocumentOverflow = document.documentElement.style.overflow;
      }

      document.documentElement.style.overflow = 'hidden';
    }

    unlockScroll() {
      document.documentElement.style.overflow = this.previousDocumentOverflow;
      this.previousDocumentOverflow = '';
    }
  }

  if (!customElements.get('full-screen-slideshow')) {
    customElements.define('full-screen-slideshow', FullScreenSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"]) return;
  try {
    
  (() => {
    const appendClones = (targets, items) => {
      targets.forEach((target) => {
        target.replaceChildren();
        items.forEach((item) => {
          target.appendChild(item.cloneNode(true));
        });
      });
    };

    const buildSection = (sectionElement) => {
      const source = sectionElement.querySelector('[data-ugc-source]');
      if (!(source instanceof HTMLElement)) return;

      const sourceItems = Array.from(source.children);
      const desktopTopTargets = sectionElement.querySelectorAll('[data-ugc-target="desktop-top"]');
      const desktopBottomTargets = sectionElement.querySelectorAll('[data-ugc-target="desktop-bottom"]');
      const mobileTopTargets = sectionElement.querySelectorAll('[data-ugc-target="mobile-top"]');
      const mobileBottomTargets = sectionElement.querySelectorAll('[data-ugc-target="mobile-bottom"]');

      const desktopRows = sectionElement.dataset.ugcDesktopRows === '2' ? 2 : 1;
      const mobileRows = sectionElement.dataset.ugcMobileRows === '2' ? 2 : 1;

      if (!sourceItems.length) {
        appendClones(desktopTopTargets, []);
        appendClones(desktopBottomTargets, []);
        appendClones(mobileTopTargets, []);
        appendClones(mobileBottomTargets, []);
        return;
      }

      const topItems = [];
      const bottomItems = [];

      sourceItems.forEach((item, index) => {
        if (index % 2 === 0) {
          topItems.push(item);
        } else {
          bottomItems.push(item);
        }
      });

      const balancedBottomItems = bottomItems.length ? bottomItems : topItems;

      appendClones(desktopTopTargets, desktopRows === 2 ? topItems : sourceItems);
      appendClones(desktopBottomTargets, desktopRows === 2 ? balancedBottomItems : []);
      appendClones(mobileTopTargets, mobileRows === 2 ? topItems : sourceItems);
      appendClones(mobileBottomTargets, mobileRows === 2 ? balancedBottomItems : []);
    };

    const setupTrackInteraction = (track) => {
      if (!(track instanceof HTMLElement)) return;
      if (track.hasAttribute('data-ugc-interaction-bound')) return;

      let pointerId = null;
      let isPointerDown = false;
      let isDragging = false;
      let hasDragged = false;
      let startX = 0;
      let startOffset = 0;
      let cycleDistance = 0;

      const getOffset = () => {
        const value = track.style.getPropertyValue('--ugc-offset-x');
        const parsed = Number.parseFloat(value);
        return Number.isNaN(parsed) ? 0 : parsed;
      };

      const setOffset = (value) => {
        track.style.setProperty('--ugc-offset-x', `${value}px`);
      };

      const normalizeOffset = (value) => {
        if (cycleDistance <= 0) return value;

        let normalized = value % cycleDistance;
        if (normalized > 0) {
          normalized -= cycleDistance;
        }

        return normalized;
      };

      const updateCycleDistance = () => {
        const firstGroup = track.firstElementChild;
        if (!(firstGroup instanceof HTMLElement)) {
          cycleDistance = 0;
          return;
        }

        const computedStyles = getComputedStyle(track);
        const gap = Number.parseFloat(computedStyles.columnGap || computedStyles.gap || '0') || 0;
        cycleDistance = firstGroup.getBoundingClientRect().width + gap;

        setOffset(normalizeOffset(getOffset()));
      };

      const setPaused = (paused) => {
        track.style.animationPlayState = paused ? 'paused' : 'running';
      };

      const onPointerMove = (event) => {
        if (!isPointerDown || event.pointerId !== pointerId) return;

        const delta = event.clientX - startX;

        if (!isDragging && Math.abs(delta) > 4) {
          isDragging = true;
          hasDragged = true;
          track.classList.add('is-dragging');
          if (!track.hasPointerCapture(event.pointerId)) {
            track.setPointerCapture(event.pointerId);
          }
        }

        if (!isDragging) return;

        const nextOffset = normalizeOffset(startOffset + delta);
        setOffset(nextOffset);

        if (event.cancelable) {
          event.preventDefault();
        }
      };

      const onPointerEnd = (event) => {
        if (!isPointerDown || event.pointerId !== pointerId) return;

        isPointerDown = false;
        isDragging = false;
        track.classList.remove('is-dragging');

        if (track.matches(':hover')) {
          setPaused(true);
        } else {
          setPaused(false);
        }

        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }

        pointerId = null;
      };

      track.addEventListener('mouseenter', () => {
        if (!isDragging) {
          setPaused(true);
        }
      });

      track.addEventListener('mouseleave', () => {
        if (!isDragging) {
          setPaused(false);
        }
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;

        pointerId = event.pointerId;
        isPointerDown = true;
        isDragging = false;
        hasDragged = false;
        startX = event.clientX;
        updateCycleDistance();
        startOffset = normalizeOffset(getOffset());
        setOffset(startOffset);

        setPaused(true);
      });

      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerEnd);
      track.addEventListener('pointercancel', onPointerEnd);

      track.addEventListener(
        'click',
        (event) => {
          if (hasDragged) {
            event.preventDefault();
            event.stopPropagation();
            hasDragged = false;
          }
        },
        true
      );

      updateCycleDistance();
      window.addEventListener('resize', updateCycleDistance);
      track.setAttribute('data-ugc-interaction-bound', 'true');
    };

    const init = (root = document) => {
      root.querySelectorAll('.ugc-videos').forEach((sectionElement) => {
        buildSection(sectionElement);
        sectionElement.querySelectorAll('.ugc-videos__desktop-track, .ugc-videos__mobile-track').forEach((track) => {
          setupTrackInteraction(track);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        init(event.target);
      }
    });

    document.addEventListener('shopify:block:select', () => init());
    document.addEventListener('shopify:block:deselect', () => init());
    document.addEventListener('shopify:section:reorder', () => init());
  })();

  } catch(e) { console.error(e); }
})();
})();
